import React, { type ComponentProps, type FC, type ReactNode } from 'react'

import { css, cx } from '@linaria/core'
import { styled } from '@linaria/react'

import { Typography } from '../../ui/Typography'
import SvgClose from '../../svgr/Close'

export const BottomSheetTitle: FC<{
  title: ReactNode
  onCloseClick: ComponentProps<typeof CloseButton>['onClick']
  mobile: boolean | null
}> = ({ title, onCloseClick, mobile }) => {
  return (
    <Title>
      <TitleLeft>
        <SvgClose />
      </TitleLeft>
      <TitleText fontSize={24} fontWeight={700}>
        {title}
      </TitleText>
      <TitleRight>
        <CloseButton
          className={cx(mobile && closeButtonMobile)}
          type="button"
          onClick={onCloseClick}
          data-name="bottom-sheet-close-action"
        >
          <SvgClose />
        </CloseButton>
      </TitleRight>
    </Title>
  )
}

const Title = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const TitleText = styled(Typography)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`
const TitleLeft = styled.div`
  visibility: hidden;
`
const TitleRight = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  font-size: 0;
`
const CloseButton = styled.button`
  border: none;
  padding: 0;
  margin: 0;
  background: transparent;
  font: inherit;
  color: inherit;
  cursor: pointer;
  outline: none;
  appearance: none;
  position: absolute;
  padding: 20px;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
`
const closeButtonMobile = css`
  display: none;
`
